<template>
  <card>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :staticFilters="staticFilters"
      :cardLink="cardLink"
      :isUpdate="true"
      :filters="filters"
      :isAdd="false"
      :setImport="true"
      :exportFields="exportFields"
      :itemLink="itemLink"
      :dateFilter="dateFilter"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        Чек: "number",
        Статус: "state",
        ТП: "plan",
        MSIMSND: "phone",
        Имя: "first_name",
        Фамилия: "last_name",
        // Отчество: "family_name",
        Дата: {
          field: "created_at",
          callback: (val) => {
            try {
              if (val && typeof val == "string") {
                let date = new Date(val);
                return date.toLocaleString();
              }
              return "Нет даты";
            } catch (error) {
              return val;
            }
          },
        },
      },
      staticFilters: [],
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      filters: [],
      params: {},
      val: [],
      modalCreate: "business",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "item_certified_check",
      itemLink: "certified_checks",
      setLink: "certified_checks",
      columns: [
        {
          key: "number",
          title: "Чек",
        },
        {
          key: "state",
          title: "Статус",
        },
        {
          key: "plan",
          title: "ТП",
        },
        {
          key: "phone",
          title: "MSIMSND",
        },
        {
          key: "first_name",
          title: "Имя",
        },
        {
          key: "last_name",
          title: "Фамилия",
        },

        {
          key: "created_at",
          title: "Дата",
          dateTimeFormat: true,
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
